import { render, staticRenderFns } from "./SlotClosureSetting.vue?vue&type=template&id=6d9f666a&scoped=true"
import script from "./SlotClosureSetting.vue?vue&type=script&lang=js"
export * from "./SlotClosureSetting.vue?vue&type=script&lang=js"
import style0 from "./SlotClosureSetting.vue?vue&type=style&index=0&id=6d9f666a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9f666a",
  null
  
)

export default component.exports